const BUNDLE_VARIANT_CONFIG = {
  // Wave Hill Chair
  '51324473966887': {
    targetVariantId: '51324473934119',
    quantityMultiplier: 2,
    discountPercentage: 12,
    discountCode: 'WAVEHILLPAIR12',
  },
  '51324473999655': {
    targetVariantId: '51324473934119',
    quantityMultiplier: 4,
    discountPercentage: 16,
    discountCode: 'WAVEHILLFOUR16',
  },
  // Westport Chair
  '49995109531943': {
    targetVariantId: '49995109466407',
    quantityMultiplier: 2,
    discountPercentage: 14,
    discountCode: 'WESTPORTPAIR14',
  },
  '50018858271015': {
    targetVariantId: '49995109466407',
    quantityMultiplier: 4,
    discountPercentage: 18,
    discountCode: 'WESTPORTFOUR18',
  },
  // Rolled Arm Chair — Cream Twill Pair
  '52087570661671': {
    // Cream Twill - Pair of Arm Chair / White Oak → 2x Cream Twill / White Oak
    targetVariantId: '51901365551399',
    quantityMultiplier: 2,
    discountPercentage: 10,
    discountCode: 'ROLLEDARMPAIR10',
  },
  '52087570694439': {
    // Cream Twill - Pair of Arm Chair / Walnut → 2x Cream Twill / Walnut
    targetVariantId: '51901365584167',
    quantityMultiplier: 2,
    discountPercentage: 10,
    discountCode: 'ROLLEDARMPAIR10',
  },
  // Russel Wright Collection
  '52175339618599': {
    // Arm Chair Pair → 2x Arm Chair
    targetVariantId: '51886582464807',
    quantityMultiplier: 2,
    discountPercentage: 5,
    discountCode: 'RUSSELWRIGHTPAIR5',
  },
  '52175339651367': {
    // Low Lounge Chair Pair → 2x Low Lounge Chair
    targetVariantId: '51886582432039',
    quantityMultiplier: 2,
    discountPercentage: 5,
    discountCode: 'RUSSELWRIGHTPAIR5',
  },
  '52175339684135': {
    // One of each chair → Arm Chair + Low Lounge + Chaise
    items: [
      { id: '51886582464807', quantity: 1 },
      { id: '51886582432039', quantity: 1 },
      { id: '51886582497575', quantity: 1 },
    ],
    discountPercentage: 10,
    discountCode: 'RUSSELWRIGHTEACH10',
  },
  // Beeswax Taper Candles
  '51918862188839': {
    // 10" Set of 4 → 2x 10" Set of 2
    targetVariantId: '51918850720039',
    quantityMultiplier: 2,
    discountPercentage: 23,
    discountCode: 'BEESWAXSET4',
  },
  '51918862221607': {
    // 10" Set of 6 → 3x 10" Set of 2
    targetVariantId: '51918850720039',
    quantityMultiplier: 3,
    discountPercentage: 30,
    discountCode: 'BEESWAXSET6',
  },
  '51918862254375': {
    // 10" Set of 8 → 4x 10" Set of 2
    targetVariantId: '51918850720039',
    quantityMultiplier: 4,
    discountPercentage: 34,
    discountCode: 'BEESWAXSET8',
  },
  '51918862287143': {
    // 10" Set of 10 → 5x 10" Set of 2
    targetVariantId: '51918850720039',
    quantityMultiplier: 5,
    discountPercentage: 37,
    discountCode: 'BEESWAXSET10',
  },
  '51918862319911': {
    // 10" Set of 20 → 10x 10" Set of 2
    targetVariantId: '51918850720039',
    quantityMultiplier: 10,
    discountPercentage: 40,
    discountCode: 'BEESWAXSET20',
  },
  '51918862352679': {
    // 12" Set of 4 → 2x 12" Set of 2
    targetVariantId: '51918850752807',
    quantityMultiplier: 2,
    discountPercentage: 23,
    discountCode: 'BEESWAXSET4',
  },
  '51918862385447': {
    // 12" Set of 6 → 3x 12" Set of 2
    targetVariantId: '51918850752807',
    quantityMultiplier: 3,
    discountPercentage: 30,
    discountCode: 'BEESWAXSET6',
  },
  '51918862418215': {
    // 12" Set of 8 → 4x 12" Set of 2
    targetVariantId: '51918850752807',
    quantityMultiplier: 4,
    discountPercentage: 34,
    discountCode: 'BEESWAXSET8',
  },
  '51918862450983': {
    // 12" Set of 10 → 5x 12" Set of 2
    targetVariantId: '51918850752807',
    quantityMultiplier: 5,
    discountPercentage: 37,
    discountCode: 'BEESWAXSET10',
  },
  '51918862483751': {
    // 12" Set of 20 → 10x 12" Set of 2
    targetVariantId: '51918850752807',
    quantityMultiplier: 10,
    discountPercentage: 40,
    discountCode: 'BEESWAXSET20',
  },
};

window.BUNDLE_VARIANT_CONFIG = BUNDLE_VARIANT_CONFIG;

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const submittedVariantId = String(formData.get('id') || '');
        const bundleConfig = BUNDLE_VARIANT_CONFIG[submittedVariantId];
        let discountCodeToApply = '';
        const rawQuantity = Number.parseInt(formData.get('quantity') || '1', 10);
        const quantity = Number.isNaN(rawQuantity) ? 1 : rawQuantity;
        let useJsonItemsPayload = false;
        let itemsPayload = null;

        if (bundleConfig) {
          discountCodeToApply = bundleConfig.discountCode || '';

          if (Array.isArray(bundleConfig.items) && bundleConfig.items.length) {
            useJsonItemsPayload = true;
            itemsPayload = bundleConfig.items.map((item) => ({
              id: Number(item.id),
              quantity: quantity * (Number(item.quantity) || 1),
            }));
          } else if (bundleConfig.targetVariantId) {
            formData.set('id', bundleConfig.targetVariantId);
            formData.set(
              'quantity',
              String(quantity * (bundleConfig.quantityMultiplier || 1))
            );
          }
        }

        if (this.cart) {
          this.cart.setActiveElement(document.activeElement);
        }

        if (useJsonItemsPayload) {
          config.headers['Content-Type'] = 'application/json';
          const jsonBody = { items: itemsPayload };
          if (this.cart) {
            jsonBody.sections = this.cart.getSectionsToRender().map((section) => section.id);
            jsonBody.sections_url = window.location.pathname;
          }
          config.body = JSON.stringify(jsonBody);
        } else {
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
          }
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: submittedVariantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              if (discountCodeToApply) {
                window.location = `/discount/${encodeURIComponent(discountCodeToApply)}?redirect=${encodeURIComponent(
                  window.routes.cart_url
                )}`;
                return;
              }
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: submittedVariantId,
                cartData: response,
              });
            this.error = false;

            if (discountCodeToApply) {
              window.location = `/discount/${encodeURIComponent(discountCodeToApply)}?redirect=${encodeURIComponent(
                window.routes.cart_url
              )}`;
              return;
            }

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
